<p>edit-contact works!</p>
